import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import Image from "next/image";
import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { Heading2 } from "../typography";

export const HowItWorks = () => {
  useSectionNavTheme({
    trigger: "#how-it-works",
    isDark: true,
    end: "200% 40px",
  });

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {
      const tl = gsap.timeline({
        ease: "none",
        scrollTrigger: {
          trigger: "#how-it-works",
          start: "top top",
          end: "bottom top",
          scrub: true,
          pin: ".how-it-works__content",
          // markers: true,
          pinSpacing: true,
          invalidateOnRefresh: true,
        },
      });
      tl.to(".how-it-works-progress-bar", { width: "100%" }) //
        .to(".data-layers", { y: 0 }, "<")
        .to(
          ".data-layers.one",
          {
            top: 50,
            left: -300,
            ease: "power4.inOut",
          },
          "<"
        )
        .to(
          ".data-layers.three",
          {
            top: -50,
            left: 300,
            ease: "power4.inOut",
          },
          "<"
        );
    });
  });
  return (
    <section
      id="how-it-works"
      className="relative flex min-h-screen w-full dark:bg-gradient-to-r from-haizea-dark via-40% via-haizea-blue/30 to-haizea-green/30 overflow-hidden py-20 lg:py-32"
    >
      <div className="how-it-works__content flex flex-col w-full items-center justify-center">
        <div className="container text-center">
          <Heading2 className="mb-8 text-4xl dark:text-slate-50">
            <span className="inline-flex flex-col justify-center">
              <span>How It Works</span>
              <div className="how-it-works-progress-bar bg-haizea-blue h-0.5 w-0"></div>
            </span>
          </Heading2>
          <p className="max-w-4xl text-xl md:text-2xl dark:text-slate-100  mx-auto">
            The system analyses satellite images to calculate how much water
            crops are actually using based on their growth and health, then
            compares this with reported meter readings.
          </p>
          <div className="flex items-center mt-8">
            <div className="relative md:mt-20 mx-auto w-[384px] h-96 max-w-full">
              <Image
                src="/images/fieldmap1.webp"
                height={400}
                width={700}
                alt="How It Works Image"
                className="data-layers one absolute w-96 h-96 top-20 md:top-0 -left-10 md:left-0 object-contain object-bottom rounded-2xl drop-shadow-2xl/50"
                unoptimized={true}
              />
              <Image
                src="/images/fieldmap2.webp"
                height={400}
                width={700}
                alt="How It Works Image"
                className="data-layers two absolute w-96 h-96 top-10 md:top-0 md:left-0 object-contain object-bottom rounded-2xl drop-shadow-2xl/50 z-10"
                unoptimized={true}
              />
              <Image
                src="/images/fieldmap3.webp"
                height={400}
                width={700}
                alt="How It Works Image"
                className="data-layers three absolute w-96 h-96 top-0 left-10 md:left-0 object-contain object-bottom rounded-2xl drop-shadow-2xl/50 z-10"
                unoptimized={true}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
